import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'
import StepRoutes from 'todistukset-ui/src/vtj/todistukset-step-routes.enum'

export const getCertPath = (
  todistusType: CertificateTypes
): string | undefined => {
  if (todistusType === CertificateTypes.AETTODISTUS) {
    return `/${PageRoutes.AETTODISTUS_ORDERER}/${StepRoutes.INSTRUCTIONS}`
  }
  if (Object.values(CertificateTypes).includes(todistusType)) {
    return `/${todistusType}/${StepRoutes.INSTRUCTIONS}`
  }
}
